//@flow
import * as React from 'react';
import { Box, Columns, Button, Heading, Flex } from '@locus-taxy/neo-ui';
import { useTranslation } from 'react-i18next';

type Props = {
    onNextClick?: () => void,
    onCancelClick?: () => void,
    onPrevClick?: () => void,
    nextDisabled?: boolean,
    titleText: string,
    nextLabel?: string
};

const TerritoryNavigationBar = (props: Props): React.Node => {
    const { t } = useTranslation();
    return (
        <Flex p="12px" bg="grey.200" justifyContent="space-between">
            <Box>
                <Heading level="4">{props.titleText}</Heading>
            </Box>
            <Columns space="small">
                {props.onCancelClick && (
                    <Button palette="danger" onClick={props.onCancelClick}>
                        {t('translations:cancel')}
                    </Button>
                )}
                {props.onPrevClick && (
                    <Button
                        appearance="solid"
                        palette="primary"
                        onClick={props.onPrevClick}
                    >
                        {t('entityManagement:previous')}
                    </Button>
                )}
                {props.onNextClick && (
                    <Button
                        appearance="solid"
                        palette="primary"
                        onClick={props.onNextClick}
                        disabled={props.nextDisabled}
                    >
                        {props.nextLabel || t('translations:next')}
                    </Button>
                )}
            </Columns>
        </Flex>
    );
};

export default TerritoryNavigationBar;
